export default __webpack_public_path__ + "static/media/ico_square_blue.7339faf1.svg";